import { IClickEventData } from 'types/analytics';

const TEXT_KEYS = {
    TITLE: 'progress-block__title',
    SUBTITLE: 'progress-block__subtitle',
    SEE_FULL: 'progress-block__see-full',
    ONE_FRIEND: 'progress-block__friend-solo',
    PLURAL_FRIENDS: 'progress-block__friend-plural',
    SEE_MORE: 'progress-block__see-more',
    CLOSE_SEE_MORE: 'progress-block__close-see-more'
};
export const REWARD_TIERS_NUMBER = 4;
export const REWARD_TIERS_MOBILE_NUMBER = 3;
export const OPEN_ALL_REWARDS_ANALYTICS: IClickEventData = {
    location: 'page',
    category: 'interaction',
    action: 'view all rewards'
};
export const OPEN_REWARD_ITEM_ANALYTICS = (rewardItem: string): IClickEventData => ({
    location: 'page',
    category: 'interaction',
    action: `see reward: ${rewardItem}`
});

export default TEXT_KEYS;
